import axios from 'axios'

export default {
    namespaced: true,
    state: {
        financialAssistanceApplicationChecklistStatuses: [],
    },
    mutations: {
        SET_FINANCIAL_ASSISTANCE_APPLICATION_CHECKLIST_STATUSES(state, payload) {
            state.financialAssistanceApplicationChecklistStatuses = payload;
        },
    },
    actions: {
        async FetchFinancialAssistanceApplicationChecklistStatuses({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/financialassistance/checklist/statuses/list`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_FINANCIAL_ASSISTANCE_APPLICATION_CHECKLIST_STATUSES', response.data.payload);
                            resolve(response.data.message);
                        }
                        else reject(response.data.message);
                    }).catch(error => reject(`FetchFinancialAssistanceApplicationChecklistStatuses: ${error.message}`));
            });
        },
    },
    getters: {
        FinancialAssistanceApplicationChecklistStatuses(state) { return state.financialAssistanceApplicationChecklistStatuses; },
    }
}
